'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM142.9 120.2l45.3 45.3 45.3-45.3c-17-17-28.3-28.3-33.9-33.9l22.6-22.6c5.7 5.7 17 17 33.9 33.9 17-17 28.3-28.3 33.9-33.9l22.6 22.6c-5.7 5.7-17 17-33.9 33.9l45.3 45.3c35.8-35.8 54.7-54.7 56.6-56.6l22.6 22.6c-1.9 1.9-20.7 20.7-56.6 56.6l45.3 45.3c17-17 28.3-28.3 33.9-33.9l22.6 22.6c-5.7 5.7-17 17-33.9 33.9 17 17 28.3 28.3 33.9 33.9l-22.6 22.6c-5.7-5.7-17-17-33.9-33.9l-45.3 45.3c35.8 35.8 54.7 54.7 56.6 56.6l-22.6 22.6c-1.9-1.9-20.7-20.7-56.6-56.6l-45.3 45.3c17 17 28.3 28.3 33.9 33.9l-22.6 22.6c-5.7-5.7-17-17-33.9-33.9-17 17-28.3 28.3-33.9 33.9l-22.6-22.6c5.7-5.7 17-17 33.9-33.9l-45.3-45.3c-35.8 35.8-54.7 54.7-56.6 56.6l-22.6-22.6c1.9-1.9 20.7-20.7 56.6-56.6l-45.3-45.3c-17 17-28.3 28.3-33.9 33.9L63.7 289.9c5.7-5.7 17-17 33.9-33.9-17-17-28.3-28.3-33.9-33.9l22.6-22.6c5.7 5.7 17 17 33.9 33.9l45.3-45.3c-35.8-35.8-54.7-54.7-56.6-56.6l22.6-22.6 11.3 11.3zm45.3 90.5l-45.3 45.3 45.3 45.3 45.3-45.3-45.3-45.3zm181 45.3l-45.3-45.3-45.3 45.3 45.3 45.3 45.3-45.3zm-67.9 67.9l-45.3-45.3-45.3 45.3 45.3 45.3 45.3-45.3zM210.7 188.1l45.3 45.3 45.3-45.3-45.3-45.3-45.3 45.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;